export const maxBannerDuration = Number.MAX_SAFE_INTEGER;
export const maxNumberImages = Number.MAX_SAFE_INTEGER;
